<template>
    <div class="order-preparation-progress-bar">
        <div class="progress">
            <div class="progress-text">
                {{ label }}: {{ preparationStatus.numerator }}
                <template v-if="preparationStatus.preparation_counters && preparationStatus.preparation_counters.nb_toremove > 0">
                    + {{ preparationStatus.preparation_counters.nb_toremove }}
                </template>
                / {{ preparationStatus.denominator }}
            </div>
            <div class="progress-bar text-center" :class="progressbarColorClass" role="progressbar" :style="'width: ' + (preparationStatus.numerator / preparationStatus.denominator * 100) + '%'" :aria-valuenow="preparationStatus.numerator / preparationStatus.denominator" aria-valuemin="0" aria-valuemax="100">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'OrderPreparationProgressBar',

        props: {
            label: {
                type: String,
                required: true,
            },
            preparationStatus: {
                type: Object,
                required: true,
            },
        },

        computed: {
            progressbarColorClass() {
                return 'preparation-bg-'+ this.preparationStatus.color;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .order-preparation-progress-bar {
        width: 100%;

        .progress-text {
            position: absolute;
            color: black;
            width: 100%;
            text-align: center;
            line-height: 2rem;
        }

        .progress {
            height: 2rem !important;
            font-size: 1.2rem;
            position: relative;
        }
    }
</style>
